import { render, staticRenderFns } from "./OrganizHeader.vue?vue&type=template&id=b599631c&scoped=true&"
import script from "./OrganizHeader.vue?vue&type=script&lang=js&"
export * from "./OrganizHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrganizHeader.vue?vue&type=style&index=0&id=b599631c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b599631c",
  null
  
)

export default component.exports